import {useMediaQuery} from '@mui/material';
import {LinkNoCrawl} from '@wandb/weave/common/util/links';
import React, {type FC} from 'react';
import {Modal, Popup} from 'semantic-ui-react';

export const ServiceAccountModal: FC<{
  serviceAccountName?: string;
  teamMembersUrl?: string;
}> = React.memo(({serviceAccountName, teamMembersUrl}) => {
  const isMobile = useMediaQuery('(max-width:1280px)');

  return (
    <Modal
      trigger={
        <span>
          <Popup
            content="The service account is used for automated systems tracking jobs. Click to learn more."
            disabled={isMobile} // disable popup on mobile (touch triggers both popup and modal)
            trigger={
              <span style={{cursor: 'pointer'}}>
                {serviceAccountName || 'Service Account'}
              </span>
            }
          />
        </span>
      }
      size="small"
      header="Service Accounts"
      actions={['Close']}
      content={
        <div className="content">
          <p>
            A service account is an API key that has permission to write to your
            team, but is not associated with a user. Service accounts are useful
            for tracking automated jobs logged to wandb, like periodic
            retraining or nightly builds.{' '}
          </p>
          <p>
            Attribute service runs to a user by setting the environment variable
            WANDB_USERNAME.
          </p>{' '}
          {/*  Disable view-only members from viewing link */}
          {teamMembersUrl && (
            <p>
              Get a service account's API key in the{' '}
              <LinkNoCrawl to={teamMembersUrl}>Members Table</LinkNoCrawl>.
            </p>
          )}
        </div>
      }
    />
  );
});
